import { isArray, isObject, camelCase, snakeCase } from "lodash";

// Using `any` here is a pragmatic choice for a generic converter utility.
// The primary type safety will be enforced at the boundaries (apiClient and hooks).
/* eslint-disable @typescript-eslint/no-explicit-any */

export function convertToCamelCase(data: any): any {
  if (isArray(data)) {
    return data.map((item) => convertToCamelCase(item));
  }

  if (isObject(data) && data !== null && !(data instanceof Date)) {
    return Object.keys(data).reduce((acc, key) => {
      const typedData = data as Record<string, any>;
      acc[camelCase(key)] = convertToCamelCase(typedData[key]);
      return acc;
    }, {} as { [key: string]: any });
  }

  return data;
}

export function convertToSnakeCase(data: any): any {
  if (isArray(data)) {
    return data.map((item) => convertToSnakeCase(item));
  }

  if (isObject(data) && data !== null && !(data instanceof Date)) {
    return Object.keys(data).reduce((acc, key) => {
      const typedData = data as Record<string, any>;
      acc[snakeCase(key)] = convertToSnakeCase(typedData[key]);
      return acc;
    }, {} as { [key: string]: any });
  }

  return data;
}
